/**
 * Financials Filters Sheet (mobile)
 * Bottom sheet with Reporting Period, ledger search, and Export for Financials page.
 */
import React from 'react';
import BottomSheet from './BottomSheet.jsx';
import ReportingPeriodBar from '../shared/ReportingPeriodBar.jsx';

export default function FinancialsFiltersSheet({
  isOpen,
  onClose,
  searchQuery,
  onSearchChange,
  exportError,
  onExportExcel,
}) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="Filters" disableDrag={false}>
      <div style={styles.content}>
        <section style={styles.section} aria-labelledby="financials-period-heading">
          <h2 id="financials-period-heading" style={styles.sectionTitle}>
            Reporting period
          </h2>
          <ReportingPeriodBar />
        </section>
        <section style={styles.section} aria-labelledby="financials-search-heading">
          <h2 id="financials-search-heading" style={styles.sectionTitle}>
            Search ledger
          </h2>
          <input
            type="text"
            placeholder="Search by guest, reservation ID, or channel…"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            style={styles.searchInput}
            aria-label="Search ledger"
          />
        </section>
        <section style={styles.section} aria-labelledby="financials-export-heading">
          <h2 id="financials-export-heading" style={styles.sectionTitle}>
            Export
          </h2>
          {exportError && (
            <span style={styles.exportError}>{exportError}</span>
          )}
          <button type="button" onClick={() => onExportExcel()} style={styles.exportButton}>
            Export to Excel
          </button>
        </section>
      </div>
    </BottomSheet>
  );
}

const styles = {
  content: {
    padding: 'var(--spacing-4) 0',
    minHeight: '40vh',
  },
  section: {
    marginBottom: 'var(--spacing-6)',
  },
  sectionTitle: {
    fontSize: 'var(--font-size-sm)',
    fontWeight: 600,
    color: 'var(--color-text-secondary, #6b7280)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 var(--spacing-3) 0',
  },
  searchInput: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '12px 16px',
    fontSize: 'var(--font-size-base, 16px)',
    border: '1px solid var(--color-border-light, #e5e7eb)',
    borderRadius: 'var(--radius-md, 6px)',
    backgroundColor: 'var(--color-bg-primary, #fff)',
    minHeight: '44px',
  },
  exportError: {
    fontSize: 'var(--font-size-xs)',
    color: 'var(--color-error, #dc2626)',
    display: 'block',
    marginBottom: 'var(--spacing-2)',
  },
  exportButton: {
    width: '100%',
    padding: '12px 16px',
    fontSize: 'var(--font-size-base, 16px)',
    fontWeight: 500,
    color: 'var(--color-text-primary)',
    backgroundColor: 'var(--color-bg-secondary, #f9fafb)',
    border: '1px solid var(--color-border-light, #e5e7eb)',
    borderRadius: 'var(--radius-md, 6px)',
    cursor: 'pointer',
    minHeight: '44px',
    textAlign: 'left',
  },
};
